import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
export const panelDeviceSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    panel_group_id: integerInRange(0, 0xffffffff),
    device_id: integerInRange(0, 0xffffffff),
    ord: integerInRange(0, 0xffffffff)
});
